/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupUserQueryResponse, TrimbleDiagnosticsControllerLookupUserPathParams, TrimbleDiagnosticsControllerLookupUser400, TrimbleDiagnosticsControllerLookupUser401, TrimbleDiagnosticsControllerLookupUser403, TrimbleDiagnosticsControllerLookupUser404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupUser";

function getTrimbleDiagnosticsControllerLookupUserUrl(tid: TrimbleDiagnosticsControllerLookupUserPathParams["tid"]) {
  const res = { method: 'GET', url: `/api/v1/trimble-user-diagnostics/${tid}` as const }  
  return res
}

/**
 * @summary Look up a Trimble IAM user and linked DC user
 * {@link /api/v1/trimble-user-diagnostics/:tid}
 */
export async function trimbleDiagnosticsControllerLookupUser(tid: TrimbleDiagnosticsControllerLookupUserPathParams["tid"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleDiagnosticsControllerLookupUserQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupUser400 | TrimbleDiagnosticsControllerLookupUser401 | TrimbleDiagnosticsControllerLookupUser403 | TrimbleDiagnosticsControllerLookupUser404>, unknown>({ method : "GET", url : getTrimbleDiagnosticsControllerLookupUserUrl(tid).url.toString(), ... requestConfig })  
  return res.data
}